import React from 'react'
import { Link } from 'react-router-dom'

const Topbar = () => {
    return (
        <>
            <section id="top-bar" className="top-bar-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 col-md-12">
                            <ul className="top-bar-order-dtls text-md-center text-lg-start">
                                <li>
                                    <Link to="#" title="">
                                        <i className="flaticon-location" />
                                        Store Location
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" title="">
                                        <i className="flaticon-tracking" />
                                        Order Tracking
                                    </Link>
                                </li>
                                <li>
                                    <Link to="telto:+222 980 78790" title="">
                                        <i className="flaticon-phone-call" />
                                        +222 980 78790
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-7 col-md-12">
                            <ul className="top-bar-service-dtls">
                                <li>
                                    <div className="tb-service">
                                        <div className="top-bar-service-dtls-icon">
                                            <i className="flaticon-box" />
                                        </div>
                                        <div className="top-bar-service-dtls-info">
                                            <h6 className="top-bar-service-dtls-title">Free Shipping</h6>
                                            <p>Free Shipping $100</p>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="tb-service">
                                        <div className="top-bar-service-dtls-icon">
                                            <i className="flaticon-support" />
                                        </div>
                                        <div className="top-bar-service-dtls-info">
                                            <h6 className="top-bar-service-dtls-title">24/7 Support</h6>
                                            <p>Super Fast Support</p>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="tb-service">
                                        <div className="top-bar-service-dtls-icon">
                                            <i className="flaticon-credit-card" />
                                        </div>
                                        <div className="top-bar-service-dtls-info">
                                            <h6 className="top-bar-service-dtls-title">Payment Secure</h6>
                                            <p>Safe Payment System</p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Topbar
